// extracted by mini-css-extract-plugin
module.exports = {"card":"InfoCard_card__2AloR","infoCard":"InfoCard_infoCard__2H2gd","title":"InfoCard_title__1zu-2","info":"InfoCard_info__2DZd1"};